﻿import React from "react";
import LazyLoad from "react-lazyload";
import {sanitiseProductName} from "../../helpers/url-helpers";

interface RelatedProductProps {
    ProductName: string;
    ThumbUrl: string;
}

const RelatedProduct = (props: RelatedProductProps) => {
    return (
        <a className="related-product" href={`/product/${sanitiseProductName(props.ProductName)}`}>
            <LazyLoad once className={"image"}>
                
                    <img src={props.ThumbUrl} alt={props.ProductName} />
            </LazyLoad>
            <div className="name">
                {props.ProductName}
            </div>
        </a>
    )
}

export default RelatedProduct;